import { useLightBox } from "../../../contexts/lightBoxContext/lightBoxContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useMailView } from "../../../contexts/mailViewContext/mailViewContext.js";
import React, { Suspense, useCallback } from "react";

const SingleElement = ({ type, id, style, isCurrent }) => {
  const { getFilesData } = useMail();

  const fileType = type || getFilesData()[id].Type;

  // START COMPONENT DETECTION SECTION
  const availableElements = ["Image", "Audio", "Video", "Doc"];

  const FileComponent = React.lazy(() =>
    import(
      `../../Reusable/FilesTypeElement/${
        availableElements.includes(fileType) ? fileType : "Doc"
      }Element.jsx`
    )
  );

  const ViewComponent = useCallback(
    () => <FileComponent id={id} lightBox={true} isCurrent={isCurrent} />,
    []
  );
  // END COMPONENT DETECTION SECTION

  const conditionToNotAnimate =
    !type &&
    (getFilesData()[id].Type === "pdf" ||
      ["Audio", "Video"].includes(fileType)) &&
    !isCurrent;

  return conditionToNotAnimate ? null : (
    <div
      className={`item-wrapper${isCurrent ? " item-in-view" : " not-in-view"}`}
      style={style}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <ViewComponent />
      </Suspense>
    </div>
  );
};

export const LightBoxSlider = () => {
  const { getFileId, getFileType } = useLightBox();
  const { getFilesList } = useMail();

  const currentIndex = getFilesList().indexOf(getFileId());

  return (
    <>
      {getFilesList().length > 0 && currentIndex >= 0 ? (
        getFilesList().map((fileId, index) => {
          if (currentIndex === index) {
            return (
              <SingleElement
                id={getFileId()}
                style={{ transform: "translateX(0)", position: "absolute" }}
                isCurrent={true}
                key={fileId}
              />
            );
          }
          if (currentIndex - 1 === index) {
            const prevId = !getFilesList()[currentIndex - 1].folder
              ? getFilesList()[currentIndex - 1]
              : getFilesList()[currentIndex - 2];

            if (!prevId) {
              return null;
            }

            return (
              <SingleElement
                id={prevId}
                style={{
                  transform: "translateX(-100vw)",
                  position: "absolute",
                }}
                key={fileId}
              />
            );
          }
          if (currentIndex + 1 === index) {
            const nextId = !getFilesList()[currentIndex + 1].folder
              ? getFilesList()[currentIndex + 1]
              : getFilesList()[currentIndex + 2];

            if (!nextId) {
              return null;
            }

            return (
              <SingleElement
                id={nextId}
                style={{
                  transform: "translateX(100vw)",
                  position: "absolute",
                }}
                key={fileId}
              />
            );
          }
          return null;
        })
      ) : (
        <SingleElement id={getFileId()} type={getFileType()} />
      )}
    </>
  );
};
